var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icons",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n      .cls-1{fill:#232323}\n    "))), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M13 0h-2a3 3 0 0 0-3 3v1H2a1 1 0 0 0 0 2h1v14a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V6h1a1 1 0 0 0 0-2h-6V3a3 3 0 0 0-3-3Zm-3 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm9 17a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14Z",
    className: "cls-1",
    style: {
      fill: "var(--primary-color)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M12 9a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0-1-1Z",
    className: "cls-1",
    style: {
      fill: "var(--primary-color)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M15 18a1 1 0 0 0 2 0v-8a1 1 0 0 0-2 0Z",
    className: "cls-1",
    style: {
      fill: "var(--primary-color)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M8 9a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0-1-1Z",
    className: "cls-1",
    style: {
      fill: "var(--primary-color)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.040dbfe9f4d8f50c1d6fd459be6c164d.svg";
export { ForwardRef as ReactComponent };